<template>
  <v-container>
    <v-row justify-sm="center">
      <v-card 
      width="90%"
      fill
      >
        <v-tabs v-model="tab" background-color="blue lighten-2 accent-4" centered dark icons-and-text>
          <v-tabs-slider></v-tabs-slider>

          

        </v-tabs>

        <v-tabs-items v-model="tab" touchless>

        </v-tabs-items>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      tab: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  methods:{
  },
  components: {
  }
};
</script>